import {
	type TProductEdition,
	type TSearchConfigAPIResponse,
} from '@atlassian/search-client/fetch-search-config';

/**
 * Gets the product edition for the given cloudId from site metadata.
 */
export const getProductEdition = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): TProductEdition | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return undefined;
	}

	return firstPartyResponse.siteMetadata.find(
		(metadata) => metadata.siteId === cloudId && !!metadata.productEdition,
	)?.productEdition;
};
